import Axios from "axios";
import React, { Component } from "react";
import { Bar } from 'react-chartjs-2';  
import AppConfig from "../../../../../../config/AppConfig";
class BarChartVerifikasi extends Component {
    constructor(props) {
        super(props)
        this.state = {
            jml_perlingkup :[],
            label :[],
            mengisi :[],
            tidakmengisi:[],
        }
      }
      
    
    options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                            return label;
                        }
   
                    },
                }
            }],
        },
    }

    async componentDidMount(){
        this.setState({display: false});
        let id_institusi = localStorage.getItem("id_sp_temp");
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let id_sp = sessiondata.i_idunit;
        if(id_institusi !== ""){
            id_sp = id_institusi;
        }if(id_institusi === null){
            id_sp = sessiondata.i_idunit;
        }
        let session = "";
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        if(userdata){
            session = 
            "?id_pengguna="+userdata.id_pengguna+
            "&id_unit="+ id_sp +
            "&id_role="+sessiondata.i_idrole;
        }
        let i = 0;
        let labels = [];
        let mengisi = [];
        let tidakmengisi = [];
          Axios.get(
            AppConfig.DetailDashboard+"persenterverifbypembina"+session
          ).then(res => {
            this.setState({
                jml_perlingkup: res.data.result.data,
            });
            for (var key in this.state.jml_perlingkup) {
                labels[i] = key;
                mengisi[i] = this.state.jml_perlingkup[key].mengisi;
                tidakmengisi[i] = this.state.jml_perlingkup[key].belum_mengisi;
                i = i + 1;
            }
            
            this.setState({
                label: labels,
                mengisi: mengisi,
                tidakmengisi: tidakmengisi,
            });
          }) 
          .catch(err => {
            alert("not found")
          }) 
    }
    render(){
        let datas = {
            labels: this.state.label,
            datasets: [
            {
                label: 'Presentase PT Terverifikasi',
                fill: false,
                lineTension: 0.1,
                backgroundColor: '#9398EC',
                borderColor: '#9398EC',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: '#9398EC',
                pointBackgroundColor: '#9398EC',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#9398EC',
                pointHoverBorderColor: '#9398EC',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: this.state.mengisi
            },
            ]
          }; 
        return(
            <>
                <Bar data={datas} 
                    options={this.options} />
            </>
        )
    }
}
export default BarChartVerifikasi;